export const isInitialized = state => state.initialized;

export const getAll = state => state.items;

export const getAllLinks = state => state.links;

export const get = state => state.item;
